export default __webpack_public_path__ + "static/media/hospital-bed.f3572608.svg";